"use client";

import { useEffect } from "react";
import * as Sentry from "@sentry/nextjs";
import { useTranslations } from "next-intl";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  // Pass-through framework control-flow signals so Next.js can complete the
  // redirect / not-found navigation instead of rendering an error UI.
  if (error.digest?.startsWith("NEXT_REDIRECT")) throw error;
  if (error.digest?.startsWith("NEXT_NOT_FOUND")) throw error;

  const t = useTranslations("common");

  useEffect(() => {
    console.error("Application error:", error);
    Sentry.captureException(error);
  }, [error]);

  return (
    <div className="flex min-h-screen items-center justify-center p-4">
      <div className="text-center space-y-4 max-w-md">
        <h1 className="text-xl font-semibold text-gray-900">{t("error")}</h1>
        <div className="flex gap-3 justify-center pt-2">
          <button
            onClick={() => (window.location.href = "/")}
            className="rounded-lg border border-gray-300 px-4 py-2 text-sm hover:bg-gray-50"
          >
            {t("nav.home")}
          </button>
          <button
            onClick={reset}
            className="rounded-lg bg-orange-600 px-4 py-2 text-sm text-white hover:bg-orange-700"
          >
            {t("retry")}
          </button>
        </div>
      </div>
    </div>
  );
}
